import styled from "styled-components";

export const PageScrollViewDiv = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
`;
